module.exports = __webpack_public_path__ + "registration-form-ca2d4608/Background_01_7x2_a-4414c1319f6a88794a2754bb02544d6e.svg";